<template>
  <div class="list-collaborator">
    <vs-table
      multiple
      v-model="collaboratorSelected"
      pagination
      max-items="5"
      @input="collaboratorSelectedChange"
      search
      :data="collaborators"
      class="table-collaborator"
    >
      <template slot="header">
        <h3>Colaboradores</h3>
      </template>
      <template slot="thead">
        <vs-th scope="col" class="th-id" sort-key="id">id</vs-th>
        <vs-th scope="col" class="th-name" sort-key="name">Nome</vs-th>
        <vs-th scope="col" class="th-send">Enviado</vs-th>
        <vs-th scope="col" class="th-aproved">Aprovado</vs-th>
        <vs-th scope="col" class="th-value" sort-key="value">Valor Total</vs-th>
        <vs-th scope="col" calss="th-visualize"></vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td data-label="id" class="td-id" :data="data[indextr].id">{{
            data[indextr].id
          }}</vs-td>
          <vs-td data-label="nome" class="td-name" :data="data[indextr].name">{{
            data[indextr].name
          }}</vs-td>
          <vs-td data-label="enviado" class="td-send">
            <i v-if="data[indextr].send" class="fa fa-check check"></i>
          </vs-td>
          <vs-td data-label="aprovado" class="td-aproved">
            <i v-if="data[indextr].aprove" class="fa fa-check check"></i>
          </vs-td>
          <vs-td
            data-label="valor total"
            class="td-value"
            :data="data[indextr].value"
          >
            <money
              calss="td-value"
              v-model="data[indextr].value"
              v-bind="money"
              class="mask-input-invisible-value-pay margin-top-specific"
              disabled
            />
          </vs-td>
          <vs-td class="td-virify">
            <div class="rigth-especific">
              <b-button size="sm" @click="clickVarify(data[indextr])"
                >Verificar</b-button
              >
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-popup
      class="benefits-utilized"
      title="Beneficios"
      @close="hideModal"
      :active.sync="modalBenefits"
    >
      <ListExpenses
        @onClosedListExpenses="onClosedListExpenses($event)"
        @onAprove="onAprove($event)"
        @onDesaprove="onDesaprove($event)"
      />
    </vs-popup>
  </div>
</template>

<script>
import { Money } from "v-money";
import ListExpenses from "@/components/modules/rh/Expenses/ListExpenses";
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";
export default {
  name: "Collaborator",
  components: {
    Money,
    ListExpenses,
  },
  props: ["collaborators", "currentMoth", "ano"],
  data() {
    return {
      collaboratorSelected: [],
      modalBenefits: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    onClosedListExpenses(evt) {
      this.$emit("onClosedListExpensesTotal", evt);
    },
    onAprove(evt) {
      this.$emit("onAprove", evt);
    },
    onDesaprove(evt) {
      this.$emit("onDesaprove", evt);
    },
    collaboratorSelectedChange() {
      this.$emit("getCollaboratorSelected", this.collaboratorSelected);
    },
    clickVarify(collaborator) {
      let data = {};
      data.collaborator = collaborator;
      data.currentMoth = this.currentMoth;
      data.ano = this.ano;
      EventBusExpenses.$emit("data", data);
      this.modalBenefits = true;
    },

    hideModal() {
      this.$emit("onCloseListCollaborator", true);
      this.modalBenefits = false;
    },
  },
};
</script>

<style scoped src="./list-collaborator.css" >
</style>
